import useSWR from "swr";
import { URL, Fetcher as F } from "../api";

export const useBaby = (filter = {}) => {
  const { puerpera } = filter;
  const params = new URLSearchParams();
  params.append("expand", "baby_bed.center");
  if (puerpera) {
    params.append("puerpera", puerpera);
  }
  const babyURL = `${URL.baby}?${params.toString()}`;
  const { data = [] } = useSWR([babyURL], F.withToken, {
    revalidateOnFocus: false,
  });

  return data;
};
